import { useQuery } from '@tanstack/react-query';
import API from '../../../../context/API';
import { useActiveStoreId } from '../../../Stores/hooks';
import { requireActiveStoreId } from '../../../../utils/activeStore';
import { SoldOutOption } from '../types';
import { QUERY_KEYS } from '../constants';

interface SoldOutOptionsPage {
  options: SoldOutOption[];
  total: number;
}

function sortByUpdatedAt(data: SoldOutOption[]): SoldOutOption[] {
  return [...data].sort(
    (a, b) => new Date(b.updatedAt || 0).getTime() - new Date(a.updatedAt || 0).getTime()
  );
}

async function fetchSoldOutOptions(page: number, limit: number, search: string): Promise<SoldOutOptionsPage> {
  const storeId = requireActiveStoreId();
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
  const response = await API.get(
    `options/stock?type=Out Of Stock&page=${page}&limit=${limit}${searchParam}&storeId=${storeId}`
  );
  const options = sortByUpdatedAt(response.data.data?.result || []);
  return { options, total: response.data.data?.total ?? 0 };
}

export function useSoldOutOptionsQuery(search: string, page: number, pageSize: number, enabled = true) {
  const storeId = useActiveStoreId();

  return useQuery({
    queryKey: [QUERY_KEYS.SOLD_OUT_OPTIONS, search, page, pageSize, storeId],
    queryFn: () => fetchSoldOutOptions(page, pageSize, search),
    staleTime: 0,
    placeholderData: (prevData, prevQuery) =>
      prevQuery?.queryKey[4] === storeId ? prevData : undefined,
    enabled: enabled && !!storeId,
  });
}
